import { Box, Typography } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { useNavigate, useParams } from "react-router-dom";
import { useProjectFeed, useTaskFeed } from "../../misc/Feed";
import { PaletteGate } from "../../misc/PaletteGate";
import { TinyButton } from "../../misc/TinyButton";
import { findColor, projectColorText } from "../../misc/projectColors";
import { useWorkspace } from "../../misc/Workspace";
import { usePanels } from "../panel/usePanels";
import { Gantt } from "../../misc/Gantt";
import { panelFontSize } from "../task/panel/PanelSection";

export function ProjectGanttPage() {
    const params = useParams();
    const navigate = useNavigate();
    const ws = useWorkspace();
    const id = parseInt(params.id || "0", 10);

    // both read through the feed, so renaming the project or moving a task's dates
    // redraws the chart without a reload. The project is asked for as a list of one,
    // since that's what the feed serves.
    const projects = useProjectFeed({ id: id });
    const list = useTaskFeed({ project: id });

    const project = projects.projects[0];
    const color = findColor(project?.color);

    // the chart already carries the task; the panel fetches its own copy either way
    const panels = usePanels({ tasks: list.tasks, projects: projects.projects });

    return (
        <PaletteGate>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, pb: 2 }}>
                <TinyButton startIcon={<ChevronLeft sx={{ fontSize: 16 }} />}
                            onClick={() => navigate(ws.path("/tasks/calendar") + "?mode=week")}>
                    Calendar
                </TinyButton>
                {project && (
                    <Typography variant="subtitle1" sx={{
                        px: 1, borderRadius: 1,
                        bgcolor: color.bg, color: projectColorText(),
                    }}>
                        {project.name}
                    </Typography>
                )}
            </Box>

            {projects.LoadingOrErrorElement}
            {list.LoadingOrErrorElement}
            {panels.LoadingOrErrorElement}

            <Gantt
                tasks={list.tasks}
                emptyText="None of this project's tasks have a due date or something to follow, so there's nothing to lay out yet."
                unplaced="list"
                selectedId={panels.task?.id}
                fontSize={panelFontSize}
                onSelect={panels.openTask}
            />

            {panels.element}
        </PaletteGate>
    );
}
